import arrowRight from '@assets/icons/icon-arrow-right.svg';
import CustomIcon from '@components/utils/CustomIcon';
import Typography from '@components/Typography';
import { useDevice } from '@contexts/device';

import { LinkContainer, LinkDescContainer, Wrapper } from './styled';

interface LandingLinkProps {
  link: string;
  linkText: string;
  containerPosition: string;
}

export const LandingLink = ({
  link,
  linkText,
  containerPosition,
}: LandingLinkProps) => {
  return link !== undefined ? (
    <LinkContainer
      $containerPosition={containerPosition}
      href={link}
      prefetch={false}
    >
      <Typography variant='caption' color='BR300' weight='SemiBold'>
        {linkText}
      </Typography>
      <CustomIcon
        width={24}
        height={24}
        paletteColor='BR300'
        icon={arrowRight}
      />
    </LinkContainer>
  ) : null;
};

interface LandingHeaderProps {
  title: string;
  description: string;
  link: string;
  linkText: string;
  hasShowAllPromotionsAction?: boolean;
  fontSize?: number;
}

export const Header = ({
  title,
  description,
  link,
  linkText,
  hasShowAllPromotionsAction = true,
}: LandingHeaderProps) => {
  const { isDesktop } = useDevice();

  return (
    <Wrapper>
      <Typography variant='Title3' color='BR300' weight='Black'>
        {title}
      </Typography>
      <LinkDescContainer>
        <Typography>{description}</Typography>
        {isDesktop && hasShowAllPromotionsAction && link ? (
          <LandingLink
            containerPosition='center'
            link={link}
            linkText={linkText}
          />
        ) : null}
      </LinkDescContainer>
    </Wrapper>
  );
};
